/**
 * ページ訪問時にGAパラメータをcookieへ保存する
 * 以降の処理は各フォーム側(Reactアプリ側)で行う
 * - 各種フォーム送信時にGAパラメータをcookieから取得し、送信データに追加する
 * - 送信完了後にGAパラメータをcookieから削除する
 */
const cf7 = () => {
  const getSearchObj = (searchStr) => {
    if (!searchStr) return {}
    const obj = {}
    searchStr
      .substr(1)
      .split('&')
      .forEach((el) => {
        const key = el.split('=')[0]
        const value = el.split('=')[1]
        obj[key] = value
      })

    if (obj.utm_referrer) {
      obj.utm_referrer_param = decodeURIComponent(obj.utm_referrer).split(
        '?',
      )[1]
      obj.utm_referrer = decodeURIComponent(obj.utm_referrer).split('?')[0]
    }
    return obj
  }

  const cookieConjunction = '__'
  const cookieMaxage = 30 * 60
  var gaData
  const gaDataArray = [
    'utm_campaign',
    'utm_content',
    'utm_medium',
    'utm_source',
    'utm_term',
  ]
  if (location.search) {
    gaData = getSearchObj(location.search)
    for (var i = 0; i < gaDataArray.length; i++) {
      for (var value in gaData) {
        if (value === gaDataArray[i]) {
          document.cookie =
            cookieConjunction +
            value +
            '=' +
            gaData[value] +
            ';max-age=' +
            cookieMaxage +
            ';path=/'
        }
      }
    }
  }
}

export default cf7
